var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loginType==0)?_c('login'):(_vm.loginType==2)?_c('demoSystemLogin'):_c('jspLogin')}
var staticRenderFns = []

export { render, staticRenderFns }